import { FC } from 'react'
import classNames from 'classnames'
import showIf from 'lib/show-if'
import css from './Slide.styles.scss'
import { SectionHeading } from 'components/headings'

interface SlideProps {
  title?: string | object
  className?: string
}

const Slide: FC<SlideProps> = ({ className = '', title, children }) => (
  <div className={classNames(css.slide, className)}>
    {showIf(title, <Title>{title}</Title>)}
    {children}
  </div>
)

interface TitleProps {
  className?: string
}

export const Title: FC<TitleProps> = ({ className = '', children }) => {
  // SectionHeading requires children to be not null
  if (children == null) {
    return null
  }

  return (
    <SectionHeading
      id="onboardingQuestion"
      className={classNames(css.title, className)}
    >
      {children}
    </SectionHeading>
  )
}

export default Slide
